import { connect } from 'react-redux';
import React from 'react';
import groupBy from 'lodash/groupBy';
import uniqBy from 'lodash/uniqBy';
import { apiDateFormatter, dateFormat } from 'lib/format';
import ScheduleCategorySection from './ScheduleCategorySection';

const compareObjectsByName = (objA, objB) => {
    const aName = objA.name.trim().toLowerCase();
    const bName = objB.name.trim().toLowerCase();
    if (aName > bName) {
        return 1;
    } else if (aName < bName) {
        return -1;
    }
    return 0;
};

const ScheduleCategoryContainer = (props) => {
    const { listings, isMobile, preauthorizedResources, selectedTab, startDateValue, userAuth, userLocation } = props;

    if (listings.length === 0) {
        const otherTabs = ['live', 'upcoming', 'replay'].filter((tab) => (tab !== selectedTab));
        return (
            <p>There are currently no {selectedTab} events for this selection.<br />
            Please check {otherTabs[0]} or {otherTabs[1]} or clear all filters.</p>
        );
    }

    const categories = uniqBy(listings.map((listing) => listing.categories[0]), 'id').sort(compareObjectsByName);
    const listingsGroupedByCategory = groupBy(listings, (listing) => listing.categories[0].id);
    const sections = categories.map((category) => {
        const categoryListings = listingsGroupedByCategory[category.id];
        return (
            <ScheduleCategorySection
                category={category}
                isMobile={isMobile}
                listings={categoryListings}
                userAuth={userAuth}
                userLocation={userLocation}
                key={`sched-category-${category.name}`}
                selectedTab={selectedTab}
                preauthorizedResources={preauthorizedResources}
            />
        );
    });

    const date = dateFormat.dateFormat(startDateValue, 'date10');
    const tableCaption = selectedTab === 'upcoming' ? <h2 className="table-caption">{ date }</h2> : null;
    return (
        <div>
            {tableCaption}
            <div>{sections}</div>
        </div>
    );
};

ScheduleCategoryContainer.defaultProps = {
    isMobile: false,
    selectedTab: 'live',
    preauthorizedResources: [],
    startDateValue: apiDateFormatter(new Date())
};

ScheduleCategoryContainer.propTypes = {
    isMobile: React.PropTypes.bool,
    listings: React.PropTypes.array,
    userLocation: React.PropTypes.object,
    userAuth: React.PropTypes.array,
    selectedTab: React.PropTypes.string,
    startDateValue: React.PropTypes.string,
    preauthorizedResources: React.PropTypes.array
};

const mapStateToProps = ({ app, authentication = {} }) => ({
    isMobile: app.isMobile,
    preauthorizedResources: (authentication.adobePass && authentication.adobePass.preauthorizedResources) || []
});

export default connect(mapStateToProps)(ScheduleCategoryContainer);



// WEBPACK FOOTER //
// ./app/schedule/ScheduleCategoryContainer.js